import "../../pages/recall-details.css";
import { convertInMonthNameFormat, cleanHTML } from "../../utils/helper";
import PropTypes from "prop-types";
import { RenderRichText } from "./render-rich-text";

export const ChildComponent = ({ item }) => {
  const hasRichData = Boolean(item?.rich_text_enabled);

  const extractUrl = (text) => {
    if (!text) return "";

    // Match first valid URL
    const urlMatch = text.match(/https?:\/\/[^\s'"]+/);
    return urlMatch ? urlMatch[0] : "";
  };

  return (
    <>
      {item?.Title && (
        <div
          style={{
            backgroundColor: "#D5E4F0",
            borderRadius: "10px",
            display: "flex",
            flexDirection: "column",
            padding: "10px",
            marginTop: "10px"
          }}>
          <h3 className="recall-summary">{item.Title}</h3>
          <div style={{ display: "flex", flexWrap: "nowrap" }}>
            {item?.RecallId && (
              <div className="col-sm-2">
                <div className="recall-details-card-item">
                  <span>{item.RecallId}</span>
                  <span> Recall ID </span>
                </div>
              </div>
            )}
            {item?.RecallDate && (
              <div className="col-sm-2">
                <div className="recall-details-card-item">
                  <span>{convertInMonthNameFormat(item.RecallDate)}</span>
                  <span>Recall Date</span>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {item?.Description && (
        <div className="recall-details-body-item">
          <h2>Description</h2>
          <p>{cleanHTML(item.Description)}</p>
        </div>
      )}
      {item?.ProductName && (
        <div className="recall-details-body-item">
          <h2>Product Name</h2>
          <p>{cleanHTML(item.ProductName)}</p>
        </div>
      )}
      {item?.items_recalled && (
        <div className="recall-details-body-item">
          <h2>Items Recalled</h2>
          {hasRichData ? (
            <RenderRichText text={item.items_recalled} />
          ) : (
            <p>{cleanHTML(item.items_recalled)}</p>
          )}
        </div>
      )}
      {item?.ConsumerContact && (
        <div className="recall-details-body-item">
          <h2>Consumer Contact</h2>
          <p>{item.ConsumerContact}</p>
        </div>
      )}
      {item?.ManufacturerName && (
        <div className="recall-details-body-item">
          <h2>Manufacturer Name</h2>
          <p>{item.ManufacturerName}</p>
        </div>
      )}
      {item?.ImageLinks && (
        <div className="recall-details-body-item">
          <h2>Images</h2>
          {item.ImageLinks.split(",").map((link, index) => (
            <img
              key={index}
              src={link}
              alt={`Product ${index + 1}`}
              style={{ maxWidth: "100px", margin: "5px" }}
            />
          ))}
        </div>
      )}
      {item?.consequences && (
        <div className="recall-details-body-item">
          <h2>Consequences</h2>
          {hasRichData ? (
            <RenderRichText text={item.consequences} />
          ) : (
            <p>{cleanHTML(item.consequences)}</p>
          )}
        </div>
      )}
      {item?.affected_locations && (
        <div className="recall-details-body-item">
          <h2>Affected Locations</h2>
          <p>{item.affected_locations}</p>
        </div>
      )}
      {item?.reason_for_recall && (
        <div className="recall-details-body-item">
          <h2>Reason for recall</h2>
          <p>{item.reason_for_recall}</p>
        </div>
      )}
      {item?.ImporterNames && (
        <div className="recall-details-body-item">
          <h2>Importer Names</h2>
          <p>{item.ImporterNames}</p>
        </div>
      )}
      {item?.Injuries && (
        <div className="recall-details-body-item">
          <h2>Injuries</h2>
          <p>{item.Injuries}</p>
        </div>
      )}
      {item?.ManufacturerCountries && (
        <div className="recall-details-body-item">
          <h2>Manufacturer Countries</h2>
          <p>{item.ManufacturerCountries}</p>
        </div>
      )}
      {item?.ProductNames && (
        <div className="recall-details-body-item">
          <h2>Product Names</h2>
          <p>{item.ProductNames}</p>
        </div>
      )}
      {item?.RemedyOptions && (
        <div className="recall-details-body-item">
          <h2>Remedy Options</h2>
          <p>{item.RemedyOptions}</p>
        </div>
      )}
      {item?.remedy && (
        <div className="recall-details-body-item">
          <h2>Remedy</h2>
          {hasRichData ? (
            <RenderRichText text={item.remedy} />
          ) : (
            <p>{cleanHTML(item.remedy)}</p>
          )}
        </div>
      )}
      {item?.source && (
        <div className="recall-details-body-item">
          <h2>Source</h2>
          {hasRichData ? (
            <RenderRichText text={item.source} />
          ) : (
            <p>{cleanHTML(item.source)}</p>
          )}
        </div>
      )}
      {item?.summary && (
        <div className="recall-details-body-item">
          <h2>Summary</h2>
          {hasRichData ? (
            <RenderRichText text={item.summary} />
          ) : (
            <p>{cleanHTML(item.summary)}</p>
          )}
        </div>
      )}
      {item?.RetailerNames && (
        <div className="recall-details-body-item">
          <h2>Retailer Names</h2>
          <p>{item.RetailerNames}</p>
        </div>
      )}
      {item?.URL && (
        <div className="recall-details-body-item">
          <h2>URL</h2>
          <a href={extractUrl(item.URL)} target="_blank" rel="noreferrer">
            Learn More
          </a>
        </div>
      )}
    </>
  );
};
ChildComponent.propTypes = {
  item: PropTypes.object.isRequired
};
